let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i9sd0")).then(() => parcelRequire('cNaUs'));